import { IconButton } from '@ui/kit';
import { CopyIcon } from '@ui/kit/icons';
import { jsx } from 'react/jsx-runtime';
import { useDuplicateCourseMutation } from '../../api/mutation.duplicate.js';

function CopyAction({
  course,
  onCopied
}) {
  const {
    mutate
  } = useDuplicateCourseMutation();
  return /*#__PURE__*/jsx(IconButton, {
    icon: /*#__PURE__*/jsx(CopyIcon, {}),
    label: "Kopier forl\xF8b",
    visibleLabel: true,
    onClick: () => {
      // Do not await duplication, we optimistically assume it is going to
      // succeed.
      mutate(course);
      onCopied();
    }
  });
}

export { CopyAction };
//# sourceMappingURL=actions.copy.js.map
